export default __webpack_public_path__ + "static/media/overviewBannerDesktop.abace1de.png";